import { Check } from "lucide-react";
const districts = ["Bünde – Ennigloh", "Hiddenhausen – Löhne", "Herford – Bad Oeynhausen", "Bad Salzuflen – Minden", "Herringhausen – Lübbecke", "Langenhagen – Burgdorf", "Sarstedt – Hildesheim", "Bielefeld – Detmold", "Lage – Bad Lippspringe", "Paderborn – Gütersloh", "Lemgo – Holzminden", "Horn Bad Meinberg", "Selze – Ronnenberg", "Laatzen – Garbsen", "Osnabrück – Ibbenbüren", "Lotte – Hasbergen", "Wallenhorst – Lengerich", "Melle – Bad Iburg", "Georgsmarienhütte", "Hannover – Lehrte"];
export default function ServiceAreasSection() {
  return <section id="service-areas-section" className="bg-background py-8 md:py-16">
      <div className="page-container flex flex-col items-center text-center">
        {}
        <div className="w-12 h-0.5 bg-accent mb-6"></div>

        {}
        <span className="text-sm font-semibold tracking-widest text-accent uppercase mb-4">
          Einzugsgebiet
        </span>

        {}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-6">Wir sind in ganz Bielefeld und <br />Umgebung für Sie da</h2>

        {}
        <p className="text-muted-foreground text-lg max-w-2xl mb-12">Von Bielefeld bis Hannover – wir kommen zu Ihnen.</p>

        {}
        <div className="flex flex-wrap justify-center gap-2 md:gap-4 max-w-4xl">
          {districts.map((district, i) => <div key={i} data-index={i} className={`inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-accent/20 text-foreground font-medium transition-colors hover:bg-accent/30 ${i >= 8 ? "hidden md:inline-flex" : "inline-flex"}`}>
              <Check className="size-4 text-accent shrink-0" />
              <span>{district}</span>
            </div>)}
        </div>
      </div>
    </section>;
}